import ActionConstants from "../action-constants";
import { createReducer } from "../utils/redux-util";
import Reducer from "./reducer";

class CartListModelBReducer extends Reducer {
    static getModelBData(state = initialState, action) {
        return {
            ...state,
            cartListModelBData: {
                getModelBName: action.payload
            } 
        }
    }
}

const cartListModelBActionHandlers = {
    [ActionConstants.GET_MODEL_NAME]: CartListModelBReducer.getModelBData
}

const initialState = {
    cartListModelBData: {
        getModelBName: false
    }
}

export const cartListModelBData = createReducer(initialState, cartListModelBActionHandlers) 